module.exports = __webpack_public_path__ + "img/1181b58c87ad42a19c7fc2f6369f2bad.a3b64b32.png";